import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TokenValidationResponse,
  MagicTokenValidationResponse,
} from "../../../model/auth-response";

const initialState: {
  data: TokenValidationResponse | MagicTokenValidationResponse | null;
  pending: boolean;
  error: boolean;
  sessionChecked: boolean;
} = {
  data: null,
  pending: false,
  error: false,
  sessionChecked: false,
};

export const tokenValidationStore = createSlice({
  name: "tokenValidation",
  initialState,
  reducers: {
    validation(state) {
      return { ...state, pending: true, error: false };
    },
    validationSuccess(
      state,
      action: PayloadAction<
        MagicTokenValidationResponse | TokenValidationResponse
      >
    ) {
      return {
        ...state,
        data: action.payload,
        pending: false,
      };
    },
    validationFail(state) {
      return { ...state, pending: false, error: true };
    },
    setSessionChecked(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        sessionChecked: action.payload,
      };
    },
  },
});

export const {
  validation,
  validationFail,
  validationSuccess,
  setSessionChecked,
} = tokenValidationStore.actions;
